import React from 'react';
import { Provider } from 'react-redux';
import store from 'store';
import GlobalStyle from 'styles/globalStyles';
import { setLocale } from 'yup';
import * as ja from 'yup-locale-ja';
import RouterHome from 'routes';

setLocale(ja.suggestive);

const App: React.FC = () => (
  <Provider store={store}>
    <GlobalStyle />
    <RouterHome />
  </Provider>
);

export default App;
